import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Prepzio admin theme. Brand accent is the same blue the old hand-rolled CSS
 * used (#2f6feb); everything else is Mantine defaults so the panel gets a
 * consistent, polished, responsive look out of the box (light + dark).
 */
const brand: MantineColorsTuple = [
  '#eef3ff',
  '#dce4f5',
  '#b9c7e2',
  '#94a8d0',
  '#748dc1',
  '#5f7cb8',
  '#5474b4',
  '#44639f',
  '#3a5890',
  '#2c4a81',
];

export const theme = createTheme({
  primaryColor: 'brand',
  colors: { brand },
  defaultRadius: 'md',
  fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  headings: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '650',
  },
});

export const COLOR_SCHEME_KEY = 'prepzio-admin-color-scheme';
